module.exports = __webpack_public_path__ + "media/images/bnr03-356c5a4a7730f52c1b15efc242516d66.png";